<template>
    <div id="uw-container-inner">
        <header class="uw-thinstrip" style="z-index:30">

            
            <div class="container" style="position:absolute;left:2.5%">
                <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
                <a class="uw-patch" href="http://uw.edu" tabindex="-1" title="University of Washington Home">Home</a> <a class="uw-wordmark" href="http://uw.edu" title="University of Washington Home">Home</a>
            </div>
        </header>
    <header id="uw-header">
        <div id="page-content" class="section-container container page-width" data-request-uri="/forms/admin/">
            <div class="section-writables">
                <div id="page-content-head" class="section-container " data-request-uri="/forms/admin/">
                    <section>
                        <h1 class="uw-site-title">{{title}}</h1>
                    </section>
                </div>
            </div>
        </div>
    </header>
        </div>
</template>

<script>
	// import Image from '../assets/img/uw-sprite-mini.svg'
    // import Navigation from './Navigation.vue'
    export default {
        name: 'UWHeader',
        components: {
            // 'Navigation': Navigation
        },
        data: function() {
            return {
                alerts: []
            }
        },
        props: ['title', 'subtitle'],
        created: function() {
            // var self = this;
        }
    }
</script>

<style scoped>
body .container {
    text-align:left;
}
/* body #uw-container {
    font-size: 17px;
    line-height: 1.72222;
} */
/* body #uw-container {
    transition: transform .3s;
} */
#uw-container div#uw-container-inner {
    box-shadow: none;
}
#uw-container div#uw-container-inner {
    position: relative;
    background-color: #fff;
    box-shadow: 10px 0 11px -6px #1f1f1f;
    transition: all .5s cubic-bezier(0.165,.84,.44,1);
}
    #notification-area {
        position: fixed;
        right: 1rem;
        top: 1rem;
        z-index: 30;
    }

	.uw-thinstrip .uw-wordmark {
		display: block;
		position: absolute;
		top: 11px;
		left: 97px;
		text-indent: -9999px;
		width: 260px;
		height: 24px;
		background: url('//apps.registrar.washington.edu/kiosk-test/img/uw-sprite-mini.svg') no-repeat 0 -74px transparent;
	}
	.uw-thinstrip .uw-patch {
		display: block;
		text-indent: -9999px;
		width: 81px;
		height: 55px;
		background: url('//apps.registrar.washington.edu/kiosk-test/img/uw-sprite-mini.svg') no-repeat 0 -3px transparent;
		position: absolute;
		top: -7px;
		left: 0;
		z-index: 1;
	}

	.uw-thinstrip {
		height: 55px;
		width: 100%;
		background: #4b2e83;
		padding-top: 7px;
		position: relative;
		z-index: 2;
		-webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
		box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
		box-sizing: border-box;
	}
</style>
